import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Input, Button, Form } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
// Removed redux login usage in favor of AuthContext based login
import flag from "./TanzaniaFlag3.avif";
import emblem from "./TanzaniaEmblem1.jpeg";
import "./styles.css";
import { useAuth } from "../../../../auth/AuthContext";
import { selectProjectAndRedirect } from "../../../../auth/postLogin";
import { useHistory, Link } from "react-router-dom";
import { useContext } from "react";
import { AppContext } from "../../../../context/AppContext";


/**
 * @class
 * @name SignIn
 * @description Sign In form  component
 * @version 0.1.0
 * @since 0.1.0
 */
const SignIn = () => {
  const { login, loading, error, token } = useAuth();
  const { setActiveProject, ensureProjects } = useContext(AppContext);
  const [formError, setFormError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();

  /**
   * @function
   * @name onFinish
   * @description collects values submitted in form
   * and dispatches login start action
   * @param {Object} values
   */
  const onFinish = async (values) => {
    setFormError("");
    setSubmitting(true);
    try {
      const { token } = await login(values);
      if (!token) {
        setFormError("Login failed");
        setSubmitting(false);
        return;
      }
  const transformed = await ensureProjects();
  // Choose latest and redirect; component will unmount after navigation
      const navigated = selectProjectAndRedirect(transformed, history, setActiveProject);
      if (!navigated) {
        setSubmitting(false);
      }
      return;
    } catch (e) {
      setFormError(e.message || 'Login failed');
      setSubmitting(false);
    }
  };


  // No activeMenuItem persistence.

  // If already authenticated (e.g., page refresh on /signin), redirect to
  // selected project overview or Exceptions. Avoid temporary navigation to '/'.
  useEffect(() => {
    if (!token) return;
    // If we're in the middle of a normal login submission, let onFinish handle redirect
    if (submitting) return;
    (async () => {
      try {
  // Derive selection similarly to post-login behavior (do not use localStorage)
  const transformed = await ensureProjects();
  selectProjectAndRedirect(transformed, history, setActiveProject);
      } catch {
        // Swallow; avoid redirecting to '/'
      }
    })();
  }, [token, submitting, history, ensureProjects, setActiveProject]);

  return (
    <div className="SignIn">
      <div className="SignInForm">
        <img src={flag} alt="Tanzanian flag" className="national-flag"></img>
        <div className="content-body">
          <img
            src={emblem}
            alt="Tanzanian national emblem"
            className="national-embelem"
          ></img>
          <div>
            <div className="Logo">
              <h2 data-testid="main-login-title">Projects Supervison tool</h2>
              <h5>Please Login to your account</h5>
            </div>
            <div style={{ color: "red" }}>{formError || error}</div>
            <Form autoComplete="off" onFinish={onFinish}>
              {/* username field */}
              <div data-testid="email-field">
                <Form.Item
                  name="email"
                  style={{ width: "100%" }}
                  rules={[
                    {
                      required: true,
                      email: true,
                      message: "Please input your username!",
                    },
                  ]}
                >
                  <Input
                    prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                    placeholder="Email"
                    data-testid="email"
                  />
                </Form.Item>
              </div>
              {/* end username field */}

              {/* password field */}
              <div data-testid="password-field">
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Password!",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                    placeholder="Password"
                    data-testid="password"
                  />
                </Form.Item>
              </div>
              {/* end password field */}

              {/* submit button */}
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  data-testid="login-button"
                  className="signIn-form-button"
                  loading={ submitting || loading }
                >
                  Log In
                </Button>
              </Form.Item>
              {/* end submit button */}
            </Form>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                Forgot password?{" "}
                <Link to={{ pathname: `/reset-password` }} data-testid="reset-password-link">Reset here</Link>{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SignIn.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
};

SignIn.defaultProps = {
  loading: false,
  error: "",
};

export default SignIn;
